import {
  SimpleGrid as MantineSimpleGrid,
  SimpleGridProps,
} from '@mantine/core';

export type ISimpleGridProps = SimpleGridProps;

/** @registry Design-layer pass-through over Mantine SimpleGrid; import this instead of @mantine/core SimpleGrid outside src/design. */
export const SimpleGrid = MantineSimpleGrid;
